module.exports = __webpack_public_path__ + "static/media/User_Icon_2.1694576b.svg";